export default {
	common: {
		subTitle: "常见问题中心",
		title: "FAQ",
		allReady: "全部已加载",
		loadFail: "加载失败",
		searchResult: "搜索结果",
		questionDetail: "Details",
		noData: "暂无信息",
		all: "全部",
		refresh: "点击重新加载",
		noInfo: "无匹配数据",
		search: "搜索",
		placeholder: "请输入问题关键字",
		isSolve:"Helpful?",
		resolved:"Yes",
		unresolved:"No",
		share: "港股美股，就选壹隆",
		onlineTip: "热线忙，优先选择我的客服",
	  	service: "电话客服",
		cancel: "取消",
		customerService: "联系客服",
		priorService: "热线忙，优先选择在线客服",
		accessService: "接入在线客服",
		allResults: '全部相关结果'
	  },
	router: {
		title: "FAQ",
		home: "",
		about: "",
	}
};
